import * as React from "react"
import { Container, Modal, Row, Col, Button, Form, Spinner, Table } from "react-bootstrap"
import { toast } from "react-toastify"
import { Subscription } from "rxjs"
import { APIError } from "../../api/ObservableFromFetch"
import ActionButton from "../ActionButton"
import { ConsortiumsMembership, RetrieveConsortiumsMembership, UpdateConsortiumsMembership } from "../../api/Randoms/RandomPersonnelListGet"
import Checkbox from "../Checkbox"

interface ConsortiumMembershipModalProps {
  PersonID: number
  onClose: () => void
}

interface ConsortiumMembershipModalState {
  saving: boolean
  loading: boolean
  data: ConsortiumsMembership[]
}

export default class ConsortiumMembershipModal extends React.PureComponent<ConsortiumMembershipModalProps, {}> {
  state: ConsortiumMembershipModalState = { saving: false, loading: false, data: [] }
  loadSubscription?: Subscription
  saveSubscription?: Subscription

  componentDidMount() {
    this.setState({ loading: true })
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.loadSubscription = RetrieveConsortiumsMembership(this.props.PersonID).subscribe(
      result => this.setState({data: result, loading: false}),
      error => this.handleAPIError(error, { loading: false })
    )
  }

  componentWillUnmount() {
    this.loadSubscription && this.loadSubscription.unsubscribe()
    this.saveSubscription && this.saveSubscription.unsubscribe()
  }

  handleAPIError = (error: Error | APIError, stateChanges: object) => {
    this.setState(stateChanges)
    error && toast.error((error as APIError)?.errorData?.message || error.message)
  }

  save = () => {
    this.setState({ saving: true })
    this.saveSubscription && this.saveSubscription.unsubscribe()
    this.saveSubscription = UpdateConsortiumsMembership(this.state.data).subscribe(
      result => {
        toast.success(result)
        this.setState({saving: false})
      },
      error => this.handleAPIError(error, { saving: false })
    )
  }

  DataRow = (data: ConsortiumsMembership, index: number) => {
    return <tr key={data.PersonAssignedToPoolID}>
      <td>{data.Name}</td>
      <td><Checkbox id={`toggleActive${data.PersonAssignedToPoolID}`} checked={data.Active} onChange={() => this.toggleActive(index)} className="mr-auto" /></td>
    </tr>
  }

  toggleActive = (index: number) => {
    const newData: ConsortiumsMembership[] = [...this.state.data]
    newData[index].Active = !newData[index].Active
    this.setState({ data: newData })
  }

  render() {
    const { saving, loading, data } = this.state

    return <Modal backdrop="static" centered show onHide={() => this.props.onClose()} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Consortiums Membership</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group as={Row}>
          <Table responsive bordered className="dark text-center">
            <thead><tr><th className="w-75">Consortium Name</th><th className="w-25">Active</th></tr></thead>
            <tbody>
              {loading ? <tr><td colSpan={2}><Spinner animation="border" size="sm" /></td></tr> : data.map((cons, index) => this.DataRow(cons, index))}
            </tbody>
          </Table>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={() => this.props.onClose()} className="mr-auto fixed-w5">CANCEL</Button>
        <ActionButton variant="primary" onClick={() => this.save()} spin={saving} disableOnSpin className="fixed-w5">UPDATE</ActionButton>
      </Modal.Footer>
    </Modal>
  }
}